module.exports = __webpack_public_path__ + "static/media/bubble-active-7.27f69d02.svg";